import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DataGrid, { Column, Scrolling } from "devextreme-react/data-grid";
import { ConfirmReturn, GetPaymentType } from "../services/CustomerToFranchaiase.service";
import { HttpStatus } from "modules/core";
import notistack from "modules/core/notistack";
import { Modal } from "react-bootstrap";
import { formatValue, getTotalDeduction } from "../services/amountFormater";

interface ReturnModalProp {
    closeModal(): void;
    reloadDataSource(): void;
    returnData: {
        returnSalesOrderModel?: any;
        returnSalesOrderItems?: any[];
    } | undefined;
}

const ReturnModal: React.FC<ReturnModalProp> = ({ returnData, reloadDataSource, closeModal }) => {
    const items = returnData?.returnSalesOrderItems ?? [];
    const [paymentList, setPaymentList] = useState<{ value: string; text: string }[]>([]);
    const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);

    const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm({
        defaultValues: {
            paymentType: "",
            paymentReferenceNumber: "",
        },
    });

    const paymentType = watch("paymentType");
    const paymentReferenceNumber = watch("paymentReferenceNumber");
    const transformedData = {
        returnSalesOrderModel: {
            salesOrderId: returnData?.returnSalesOrderModel?.salesOrderId ?? 0,
            totalReturnSaleOrderAmount: items[0]?.returnSaleOrderAmount ?? 0,
            totalQuantity: 1,
            returnSaleType: "Return",
            customerId: items[0]?.customerId ?? 0,
            storeId: returnData?.returnSalesOrderModel?.storeId,
            salesPersonId: returnData?.returnSalesOrderModel?.salesPersonId,
            paymentType,
            paymentReferenceNumber,
            description: ""
        },
        returnSalesOrderItems: items.map(item => ({
            styleNo: item.styleNo ?? 0,
            categoryName: item.categoryName,
            diamondWeight: item.diamondWeight,
            netWeight: item.netWeight,
            actualNetWeight: 0,
            grossWeight: 0,
            metalPrice: 0,
            laborPrice: item.laborPrice,
            diamondQuantity: item.diamondQuantity,
            quantity: 1,
            saleOrderAmount: item.saleOrderAmount,
            returnSaleOrderAmount: 0,
            materialTypeId: item.materialTypeId,
            materialTypeName: item.materialTypeName,
            productHeaderId: item.productHeaderId,
            customerId: item.customerId,
            salesOrderItemId: items[0]?.id,
            refundRewardPoints: item?.refundRewardPoints ?? 0,
            rewardExpiryDays: item?.rewardExpiryDays ?? 0
        }))
    };

    useEffect(() => {
        getPaymentTypeList();
    }, []);

    const getPaymentTypeList = async () => {
        try {
            const response = await GetPaymentType();
            if (response.status === HttpStatus.Success) {
                setPaymentList(response.data);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.notifyFromApi(error.message);
        }
    };

    const handleReturn = async () => {
        try {
            const response = await ConfirmReturn(transformedData);
            if (response.status === HttpStatus.Success) {
                notistack.notifyFromApi(response);
                reloadDataSource();
                closeModal();
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.notifyFromApi(error.message);
        }
    };

    const handleCancel = () => {
        reloadDataSource();
        closeModal();
    };
    return (
        <>
            <div className="">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="row py-3" style={{ width: "60%" }}>
                        <div className="col-md-12">
                            <h6 className="fw-bold">Edit Price</h6>
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <label className="form-label small">IGI NO </label>
                                    <input type="text" className="form-control form-control-sm" value={items[0]?.igiNo ?? ''} readOnly />
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <label className="form-label small">Return Price </label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={
                                            returnData?.returnSalesOrderModel?.totalReturnSaleOrderAmount != null
                                                ? (returnData.returnSalesOrderModel.totalReturnSaleOrderAmount).toFixed(2)
                                                : ""
                                        }
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <h6 className="fw-bold">Payment Method</h6>
                            <form className="row">
                                <div className="col-sm-4 mb-2">
                                    {/* <label className="form-label small">Payment Type <span className="text-danger">*</span></label> */}
                                    <label className="form-label small">Payment Type <span className="text-danger">*</span></label>
                                    <select
                                        className="form-select form-select-sm custom-select-style"
                                        {...register("paymentType", {
                                            required: "Select payment type"
                                        })}
                                    >
                                        <option value="">Payment Type</option>
                                        {paymentList?.map(p => (
                                            <option value={p.text} key={p.value}>
                                                {p.text}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.paymentType && (
                                        <p className="text-danger">{errors.paymentType.message}</p>
                                    )}
                                </div>
                                <div className="col-sm-4 mb-2">
                                    <label className="form-label small">Reference </label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        {...register("paymentReferenceNumber")}
                                        maxLength={200}
                                    />
                                </div>
                                <div className="col-sm-4 mb-2">
                                    <label className="form-label small">Amount </label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={
                                            returnData?.returnSalesOrderModel?.totalReturnSaleOrderAmount != null
                                                ? (returnData.returnSalesOrderModel.totalReturnSaleOrderAmount).toFixed(2)
                                                : ""
                                        }
                                        readOnly
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row" style={{ width: "50%" }}>
                        <div className="overflow-auto" style={{ height: '300px' }}>
                            <h6 className="fw-bold text-center mb-0">Deduction Summary</h6>

                            {items.map((item, index) => (
                                <div key={item.id || index} className="card p-0 mb-0 shadow-sm border-0 rounded-3">
                                    <div className="card-body mb-0 p-2 border-bottom">
                                        <h6 className="fw-semibold">
                                            {item.categoryName} (Style No: {item.styleNo})
                                        </h6>

                                        <table className="table table-sm table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "200px" }}>Header</th>
                                                    <th>Original Amt</th>
                                                    <th>Return Amt</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item?.deductionSummarys &&
                                                    Object.entries(item.deductionSummarys).map(([key, value]: [string, any]) => (
                                                        <tr key={key}>
                                                            <td><strong>{key}</strong></td>
                                                            <td>{formatValue(value?.orignalAmount)}</td>
                                                            <td>{formatValue(value?.returnAmount)}</td>
                                                        </tr>
                                                    ))}
                                                {item?.deductionSummarys && (
                                                    <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "red" }}>
                                                        <td>Total</td>
                                                        <td>
                                                            {formatValue(
                                                                Object.values(item.deductionSummarys).reduce(
                                                                    (sum: number, v: any) => sum + (v?.orignalAmount || 0),
                                                                    0
                                                                )
                                                            )}
                                                        </td>
                                                        <td>
                                                            {formatValue(
                                                                Object.values(item.deductionSummarys).reduce(
                                                                    (sum: number, v: any) => sum + (v?.returnAmount || 0),
                                                                    0
                                                                )
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <DataGrid
                dataSource={items}
                keyExpr="id"
                showBorders={true}
                showRowLines={true}
                columnAutoWidth={true}
                noDataText="No Return Items Found"
            >
                <Scrolling
                    mode='standard'
                    useNative={true}
                    scrollByContent={true}
                    scrollByThumb={true}
                />
                {/* <Column dataField="image" caption="Image" width={80} /> */}
                <Column dataField="styleNo" caption="Style No" width={120} />
                <Column dataField="categoryName" caption="Category" width={150} />
                <Column dataField="diamondWeight" caption="Dia.Wt" dataType="number" width={100} format="#,##0.000" />
                <Column dataField="diamondQuantity" caption="Dia.Qty" dataType="number" width={100} />
                <Column dataField="netWeight" caption="Net Wt" dataType="number" width={100} format="#,##0.000" />
                <Column dataField="grossWeight" caption="Gross Wt" dataType="number" width={100} format="#,##0.000" />
                <Column dataField="metalPrice" caption="Metal Price" dataType="number" width={120} format="#,##0.00" />
                <Column dataField="laborPrice" caption="Lab Price" dataType="number" width={100} format="#,##0.00" />
                <Column dataField="diamonMrp" caption="Dia Price" dataType="number" width={100} format="#,##0.00" />
                <Column dataField="colorStonePrice" caption="Stone Price" dataType="number" width={100} format="#,##0.00" />
                <Column dataField="quantity" caption="Quantity" dataType="number" width={100} />
                <Column dataField="igiNo" caption="IGI NO" dataType="number" width={100} />
                <Column dataField="saleOrderAmount" caption="Selling Price" dataType="number" width={100} format="#,##0.00" />
                <Column dataField="returnSaleOrderAmount" caption="Return Price" dataType="number" width={100} format="#,##0.00" />
            </DataGrid>

            <div className="d-flex align-content-center justify-content-end gap-3 p-4">
                Total Price : {
                    returnData?.returnSalesOrderModel?.totalReturnSaleOrderAmount != null
                        ? (returnData.returnSalesOrderModel.totalReturnSaleOrderAmount).toFixed(2)
                        : ""
                }
                <button className="btn add-btn" onClick={() => setShowCancelConfirmModal(true)}>Cancel</button>
                <button className="submit-btn btn" disabled={isSubmitting} onClick={handleSubmit(handleReturn)}>Confirm</button>
            </div>

            <Modal show={showCancelConfirmModal} onHide={() => setShowCancelConfirmModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Cancel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to cancel? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn add-btn" onClick={() => setShowCancelConfirmModal(false)}>
                        No, Go Back
                    </button>
                    <button className="btn submit-btn" onClick={() => {
                        handleCancel();
                        setShowCancelConfirmModal(false);
                    }}>
                        Yes, Cancel It
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ReturnModal;
